import { RouteTabs } from '../../components/route-tabs';

const reportTabs = [
  { to: '/stores/$storeId/reports/popularity', label: 'Popularity' },
  { to: '/stores/$storeId/reports/stocking-issues', label: 'Possible Stocking Issues' },
  { to: '/stores/$storeId/reports/phantom-inventory', label: 'Phantom Inventory' },
  { to: '/stores/$storeId/reports/underperforming-inventory', label: 'Underperforming Inventory' },
  { to: '/stores/$storeId/reports/negative-inventory', label: 'Negative Inventory' },
  { to: '/stores/$storeId/reports/previous-day-sales', label: 'Previous Day Sales' },
  { to: '/stores/$storeId/reports/low-stock', label: 'Low Stock' },
  { to: '/stores/$storeId/reports/exception-logs', label: 'Exception Logs' },
  { to: '/stores/$storeId/reports/sales-journal', label: 'Sales Journal' },
] as const;

export function ReportsLayout() {
  return <RouteTabs tabs={reportTabs} />;
}
